import React from "react";

const SapCsvSafeInput = ({
    value = "",
    onChange,
    as = "input",
    maxLength,
    inputRef,
    ...props
}) => {

    const sanitizeSapText = (text) => {
        if (!text) return "";

        let cleaned = text;

        cleaned = cleaned.replace(/[–—−]/g, "-");
        cleaned = cleaned.replace(/[‘’']/g, ""); 
        cleaned = cleaned.replace(/[“”]/g, "");
        cleaned = cleaned.replace(/[•…™®©]/g, ""); 
        cleaned = cleaned.replace(/[₹€£]/g, "");
        cleaned = cleaned.replace(/[,"|;\\]/g, "");
        cleaned = cleaned.replace(/\u00A0/g, " ");
        cleaned = cleaned.replace(/[\r\n]+/g, " ");
        cleaned = cleaned.replace(/[^\x20-\x7E]/g, "");
        cleaned = cleaned.replace(/^\s+/, "");

        if (maxLength) {
            cleaned = cleaned.slice(0, maxLength);
        }

        return cleaned;
    };

    const handleChange = (e) => {
        const cleanedValue = sanitizeSapText(e.target.value);
        onChange?.(cleanedValue);
    };

    if (as === "textarea") {
        return (
            <textarea
                {...props}
                value={value}
                onChange={handleChange}
                maxLength={maxLength}
                ref={inputRef || null}
            />
        );
    }

    return (
        <input
            {...props}
            value={value}
            ref={inputRef || null}
            onChange={handleChange}
            maxLength={maxLength}
        />
    );
};

export default SapCsvSafeInput;